export const defaultNamespace = 'u'
const statePrefix = 'is-'

const _bem = (
  namespace: string,
  block: string,
  blockSuffix: string,
  element: string,
  modifier: string,
) => {
  let cls = `${namespace}-${block}`
  if (blockSuffix) {
    cls += `-${blockSuffix}`
  }

  if (element) {
    cls += `__${element}`
  }

  if (modifier) {
    cls += `--${modifier}`
  }

  return cls
}

export const useNamespace = (block: string) => {
  const namespace = defaultNamespace

  const b = (blockSuffix = '') => _bem(namespace, block, blockSuffix, '', '')
  const e = (element?: string) =>
    element ? _bem(namespace, block, '', element, '') : ''

  const m = (modifier?: string) =>
    modifier ? _bem(namespace, block, '', '', modifier) : ''

  const be = (blockSuffix?: string, element?: string) => {
    if (blockSuffix && element) {
      return _bem(namespace, block, blockSuffix, element, '')
    }
    else {
      return ''
    }
  }

  const em = (element?: string, modifier?: string) => {
    if (element && modifier) {
      return _bem(namespace, block, '', element, modifier)
    }
    else {
      return ''
    }
  }
  const bm = (blockSuffix?: string, modifier?: string) => {
    if (blockSuffix && modifier) {
      return _bem(namespace, block, blockSuffix, '', modifier)
    }
    else {
      return ''
    }
  }
  const bem = (blockSuffix?: string, element?: string, modifier?: string) => {
    if (blockSuffix && element && modifier) {
      return _bem(namespace, block, blockSuffix, element, modifier)
    }
    else {
      return ''
    }
  }

  const is: {
    (name: string, state: boolean | undefined): string
    (name: string): string
  } = (name: string, ...args: [boolean | undefined] | []) => {
    const state = args.length >= 1 ? args[0]! : true
    if (name && state) {
      return `${statePrefix}${name}`
    }
    else {
      return ''
    }
  }

  // for css var
  // --{namespace}-xxx: value;
  const cssVar = (object: Record<string, string>) => {
    const styles: Record<string, string> = {}
    for (const key in object) {
      if (object[key]) {
        styles[`--${namespace}-${key}`] = object[key]
      }
    }

    return styles
  }
  // with block
  const cssVarBlock = (object: Record<string, string>) => {
    const styles: Record<string, string> = {}
    for (const key in object) {
      if (object[key]) {
        styles[`--${namespace}-${block}-${key}`] = object[key]
      }
    }

    return styles
  }

  const cssVarName = (name: string) => `--${namespace}-${name}`
  const cssVarBlockName = (name: string) => `--${namespace}-${block}-${name}`

  return {
    namespace,
    b,
    e,
    m,
    be,
    em,
    bm,
    bem,
    is,
    // css
    cssVar,
    cssVarName,
    cssVarBlock,
    cssVarBlockName,
  }
}

export type UseNamespace = ReturnType<typeof useNamespace>
